import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import Focusable, { FocusEventListener } from '@philips-emr/tws-core/lib/component/types/focusable';

class SwitchAPI extends ComponentAPI implements Changeable<boolean>, Focusable {

  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<boolean>();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  getClassName(): string {
    return this.state.className;
  }

  setClassName(className: string): void {
    this.setState({ className });
  }

  getEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  getOffExpression(): string {
    return this.state.offExpression;
  }

  setOffExpression(offExpression: string): void {
    this.setState({ offExpression });
  }

  getOnExpression(): string {
    return this.state.onExpression;
  }

  setOnExpression(onExpression: string): void {
    this.setState({ onExpression });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  isShowStatus(): boolean {
    return this.state.showStatus;
  }

  setShowStatus(showStatus: boolean): void {
    this.setState({ showStatus });
  }

  getValue(): boolean {
    return this.state.value;
  }

  setValue(value: boolean): void {
    const { value: oldValue } = this.state;
    this.setState({ value });

    this.onChange.fire({ value, oldValue });
  }
}

export default SwitchAPI;
